/**
 * Control and format characters, removed from a name **on its way to a screen** [03-us-kad-6d AC-6].
 *
 * ⛔ **NOT XSS** — React escapes markup, and this app never sets `innerHTML`. The characters this removes
 * are invisible ones that change what a **correct** string means:
 *
 *  - `U+202E RIGHT-TO-LEFT OVERRIDE` in a pasted name makes *09 · Ready* assert a different kiosk-and-venue
 *    binding than the one just established, in the one sentence a staffer reads before walking away — and
 *    under [0148] the venue comes only from the PIN, so a mis-read binding is candidates applying against
 *    another site's orders.
 *  - a newline or a `U+0000` turns a one-line label into something the three staff surfaces [0118] lay out
 *    differently from each other.
 *
 * ⭐ **At RENDER, never at the value.** [0118] rules the name is kept **as typed** and [0149] rules that a
 * collision — not the content — is the only refusal, so nothing here touches what is stored or what is sent:
 * `typeName` bounds the length and changes nothing else, and the api receives exactly what was typed. This
 * is a presentation rule, applied where a sentence is assembled.
 *
 * `\p{Cc}` is the C0/C1 controls and `\p{Cf}` the format characters — the bidi overrides, the zero-width
 * joiners and the byte-order mark. Everything a person can see survives untouched, including the emoji,
 * accents and punctuation a staffer may legitimately put on a tag.
 */
const INVISIBLE = /[\p{Cc}\p{Cf}]/gu;

export function forDisplay(name: string): string {
  return name.replace(INVISIBLE, '');
}
